/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free BMR and TDEE calculator. Find your basal metabolic rate and total daily energy expenditure from your sex, weight, height, age and activity level.`)
};

const es_bmr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de BMR y TDEE gratuita. Estima tu tasa metabólica basal y tus necesidades calóricas diarias a partir de altura, peso, edad, sexo y nivel de actividad.`)
};

const de_bmr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser BMR- und TDEE-Rechner. Schätzen Sie Ihren Grundumsatz und Ihren täglichen Kalorienbedarf anhand von Größe, Gewicht, Alter, Geschlecht und Aktivitätsniveau.`)
};

const nl_bmr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis BMR en TDEE-rekenmachine. Schat uw basaal metabolisch tarief en dagelijkse caloriebehoeften in op basis van lengte, gewicht, leeftijd, geslacht en activiteitsniveau.`)
};

const fr_bmr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur BMR et TDEE gratuit. Estimez votre taux métabolique de base et vos besoins caloriques quotidiens en fonction de votre taille, poids, âge, sexe et niveau d'activité.`)
};

const it_bmr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore BMR e TDEE gratuito. Stima il tuo metabolismo basale e il fabbisogno calorico giornaliero dall'altezza, peso, età, sesso e livello di attività.`)
};

const pt_br2_bmr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora gratuita de BMR e TDEE. Estime sua taxa metabólica basal e necessidades calóricas diárias a partir de altura, peso, idade, sexo e nível de atividade.`)
};

const pt_bmr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de TMB e TDEE gratuita. Estime a sua taxa metabólica basal e necessidades calóricas diárias a partir de altura, peso, idade, sexo e nível de atividade.`)
};

const ja_bmr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のBMRおよびTDEE計算機。身長、体重、年齢、性別、活動レベルから基礎代謝率および日次カロリー必要量を推定します。`)
};

const zh_bmr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的 BMR 和 TDEE 计算器。根据身高、体重、年龄、性别和活动水平，估算您的基础代谢率和每日热量需求。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmr_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmr_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmr_meta_description", locale)
	if (locale === "en") return en_bmr_meta_description(inputs)
	if (locale === "es") return es_bmr_meta_description(inputs)
	if (locale === "de") return de_bmr_meta_description(inputs)
	if (locale === "nl") return nl_bmr_meta_description(inputs)
	if (locale === "fr") return fr_bmr_meta_description(inputs)
	if (locale === "it") return it_bmr_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_bmr_meta_description(inputs)
	if (locale === "pt") return pt_bmr_meta_description(inputs)
	if (locale === "ja") return ja_bmr_meta_description(inputs)
	return zh_bmr_meta_description(inputs)
};